import { render, staticRenderFns } from "./swiper-common.vue?vue&type=template&id=faea2a58&scoped=true&"
import script from "./swiper-common.vue?vue&type=script&lang=js&"
export * from "./swiper-common.vue?vue&type=script&lang=js&"
import style0 from "./swiper-common.vue?vue&type=style&index=0&id=faea2a58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faea2a58",
  null
  
)

export default component.exports